import { render, staticRenderFns } from "./wel.vue?vue&type=template&id=240efbe7&scoped=true"
import script from "./wel.vue?vue&type=script&lang=js"
export * from "./wel.vue?vue&type=script&lang=js"
import style0 from "./wel.vue?vue&type=style&index=0&id=240efbe7&prod&scoped=scoped&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_css-loader@5.2.7_prettier@2.8.7_react-dom@17.0.2_react@_xbvnx5joxenxrdtaq55cnp74na/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240efbe7",
  null
  
)

export default component.exports